import { render, staticRenderFns } from "./PagamentoAprovado.vue?vue&type=template&id=5081dcf6&scoped=true"
import script from "./PagamentoAprovado.vue?vue&type=script&lang=js"
export * from "./PagamentoAprovado.vue?vue&type=script&lang=js"
import style0 from "./PagamentoAprovado.vue?vue&type=style&index=0&id=5081dcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5081dcf6",
  null
  
)

export default component.exports